module.exports = __webpack_public_path__ + "img/bmw.85dd1537.webp";